import { useQrShowState } from "@/states/qr.state";
import { useState } from "react";
import { formatFileErrorMessage, Storage } from "src/helper/helper";
interface ErrorMessage {
  largeFile: string;
  invalidType: string;
}
const useFileUpload = (translate?: (key: string) => string, func?: (params: any) => void) => {
  const {
    insertQrData,
    removeQrData
  } = useQrShowState.getState();
  const [errorMessage, setErrorMessage] = useState<ErrorMessage>({
    largeFile: "",
    invalidType: ""
  });
  const handleFileRejectionErrors = (fileRejections: any[]) => {
    let largeFileErrorMessage = "";
    let invalidTypeErrorMessage = "";
    fileRejections.forEach(file => {
      file.errors.forEach((err: any) => {
        const formattedErrorMessage = formatFileErrorMessage(err, translate);
        if (err.code === "file-too-large") {
          largeFileErrorMessage = formattedErrorMessage;
        }
        if (err.code === "file-invalid-type") {
          invalidTypeErrorMessage = formattedErrorMessage;
        }
      });
    });
    const newErrorMessage = {
      largeFile: invalidTypeErrorMessage ? "" : largeFileErrorMessage || "",
      invalidType: invalidTypeErrorMessage || ""
    };
    setErrorMessage(newErrorMessage);

    // Ensure 'data' exists in the state before updating it
    if (newErrorMessage.invalidType || newErrorMessage.largeFile) {
      // Get and parse the storage content
      func?.({
        id: null
      });
      insertQrData("hasFileError", true);
    } else {
      removeQrData("hasFileError");
    }
  };
  const hasFileUploadErr = errorMessage.invalidType || errorMessage.largeFile;
  return {
    errorMessage,
    setErrorMessage,
    handleFileRejectionErrors,
    hasFileUploadErr
  };
};
export default useFileUpload;